module.exports = __webpack_public_path__ + "static/applicationsMobile-fa721a72e04aaef1cd1c3e59379241b8.webp";